import { FC, useEffect, useState } from 'react'
import CampaignParticipantApi from '../../../../infrastructure/api/CampaignParticipantApi'
import { ICampaignParticipantModel } from '../../../../models/responses/CampaignParticipantModel'
import { PagedResponseModel } from '../../../../models/responses/PagedResponseModel'
import { IPaginationFilter } from '../../../../models/requests/PaginationFilter'
import { GenericTable } from '../../../components/tables/GenericTable'
import { TableHelperButtons } from '../../../components/buttons/TableHelperButtons'
import { TableHelperButtonEnum } from '../../../enums/TableHelperButtonEnum'

type Props = {
  onClickItem: (itemId: any, itemName: string, type: string) => void
  refresh: number
}

const CampaignParticipantListModal: FC<Props> = ({ onClickItem, refresh }) => {
  const [campaignParticipants, setCampaignParticipants] =
    useState<PagedResponseModel<ICampaignParticipantModel[]>>()
  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [searchText, setSearchText] = useState('')
  const [sort, setSort] = useState('date_desc')

  useEffect(() => {
    const paginationFilter: IPaginationFilter = {
      page: pageNumber,
      size: pageSize,
      orderBy: sort,
      search: searchText,
    }
    async function getCampaignParticipants() {
      var response = await CampaignParticipantApi.GetCampaignParticipants(paginationFilter)
      setCampaignParticipants(response.data)
    }
    getCampaignParticipants()
  }, [refresh, pageNumber, pageSize, searchText, sort])

  return (
    <>
      <GenericTable
        title='CampaignParticipants'
        data={campaignParticipants?.items}
        currentTotalRecords={campaignParticipants?.totalRecords!!}
        currentPageNumber={campaignParticipants?.pageNumber!!}
        columns={[
          {
            label: '#',
            name: '#',
            options: {
              customBodyRenderLite: (dataIndex) => {
                return <>{(pageNumber - 1) * pageSize + ++dataIndex}</>
              },
              sort: false,
              viewColumns: false
            },
          },
          { label: 'Username (Entry)', name: 'participantId' },
          { label: 'Name', name: 'name' },
          { label: 'Surname', name: 'surname' },
          { label: 'Phone', name: 'phone' },
          { label: 'Email', name: 'email' },
          {
            label: 'Campaign',
            name: 'campaignName',
            options: {
              customBodyRender: (value) => {
                return <b>{value}</b>
              },
              sort: false
            },
          },
          { label: 'Date', name: 'date' },
          {
            label: '#',
            name: 'Id',
            options: {
              customHeadLabelRender: (options) => {
                return (
                  <div className='d-flex justify-content-end flex-shrink-0'>{options.label}</div>
                )
              },
              customBodyRenderLite: (dataIndex) => {
                return (
                  <TableHelperButtons
                    itemId={campaignParticipants?.items[dataIndex]?.id!!}
                    itemParam={campaignParticipants?.items[dataIndex]?.name!!}
                    types={[TableHelperButtonEnum.Delete]}
                    onClickItem={onClickItem}
                  />
                )
              },
              filter: false,
              sort: false,
              viewColumns: false,
            },
          },
        ]}
        customOptions={{
          rowsPerPage: pageSize,
          customTableBodyFooterRender: (opts) => {
            return <div></div>
          },
        }}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        setSearchText={setSearchText}
        setSort={setSort}
      />
    </>
  )
}

export { CampaignParticipantListModal }
